import './groupDialog.less';

import * as _ from 'lodash';
import { claimTypes } from '../../objects/Claim';
import { getAttachmentTypeName } from '../../objects/Attachment';
import { AuditEntry } from '../../components/auditlog/auditlogComponent';
import { getCertificationState, getClaimStateText, getRemunerationTitle } from '../../misc/textHelper';
import { CertificationRecalledResult, ClaimRecalledResult, RemunerationDeletedResult } from './GroupDialogResult';
import { remunerationTypes } from '../../objects/Payslip';
import { SimpleGroupModel } from '../simple/SimpleGroupModel';
import { ProposedGroupModel } from '../proposed/ProposedGroupModel';
import { ComplexGroupModel } from '../complex/ComplexGroupModel';

/**
 * @typedef { import('../PaymentGroupModel').PaymentGroupModel } PaymentGroupModel
 * @typedef { import('../../server/ApiServer').ApiServer } ApiServer
 */

angular.module("tromanWeb").controller('GroupDialogController', ['ObjectCache', 'tromanServer', 'downloadService', 'dialogService', '$uibModalInstance', '$scope', 'paymentGroup', 
    /**
     * @param {ObjectCache} ObjectCache
     * @param {ApiServer} tromanServer
     * @param {any} downloadService
     * @param {any} $scope
     * @param {PaymentGroupModel} paymentGroup
     */
    function (ObjectCache, tromanServer, downloadService, dialogService, $uibModalInstance, $scope, paymentGroup) {

        ObjectCache.getAllUsers().then(result => {
            if (paymentGroup.remuneration != null) {
                this.audit = AuditEntry.generateAudit(paymentGroup.remuneration.AuditEntries, result);
            } else if (paymentGroup.claim != null) {
                this.audit = AuditEntry.generateAudit(paymentGroup.claim.AuditEntries, result);
            } else {
                this.audit = [];
            }
        });

        this.paymentGroup = paymentGroup;
        this.claimTypes = claimTypes;
        this.canRecallClaim = paymentGroup.hasClaim && !paymentGroup.isAdded;
        const certificationStarted = paymentGroup.certPending || paymentGroup.certCertified;
        this.canRecallCertification = certificationStarted && !paymentGroup.hasClaim;
        this.canDelete = !certificationStarted && !paymentGroup.hasClaim;

        if (paymentGroup instanceof SimpleGroupModel) {
            this.title = getRemunerationTitle(paymentGroup.remunerationType, paymentGroup.claim?.ClaimType);
        } else if (paymentGroup instanceof ProposedGroupModel) {
            this.title = getRemunerationTitle(remunerationTypes.claim, paymentGroup.claim?.ClaimType);
        } else if (paymentGroup instanceof ComplexGroupModel) {
            this.title = getRemunerationTitle(paymentGroup.remuneration.RemunerationType, paymentGroup.claim?.ClaimType);
        }

        if (paymentGroup.claim != null) {
            this.claim = paymentGroup.claim;
            this.nugget = paymentGroup.claim.Nugget;
            this.status = getClaimStateText(this.claim.State);
            if (paymentGroup.hasCertification) {
                this.status = this.status + ', ' + getCertificationState(paymentGroup.remuneration.CertificationState);
            }
        } else {
            this.status = getCertificationState(paymentGroup.remuneration?.CertificationState);
        }

        this.close = function () {
            $scope.$close();
        };

        this.deleteRemuneration = function() {
            dialogService.confirm(['Radera ersättning inklusive alla arvoden']).then(() => {
                tromanServer.Payroll.deleteRemuneration(paymentGroup.remuneration.Id).then(() => {
                    $uibModalInstance.close(new RemunerationDeletedResult(paymentGroup.remuneration.Id));
                }).catch(err => {
                    this.error = err;
                });
            });
        };

        this.attachmentTitle = function (attachment) {
            return getAttachmentTypeName(attachment.AttachmentType);
        };

        this.downloadAttachment = function (attachment) {
            tromanServer.Files.downloadAttachment(attachment.Id)
                .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename));
        };

        this.recallClaim = function () {
            dialogService.confirm(['Återkalla godkännande av anspråk?']).then(() => {
                tromanServer.Payroll.recallClaim({
                    Id: paymentGroup.remuneration.Id,
                }).then(result => {
                    $uibModalInstance.close(new ClaimRecalledResult(result));
                }).catch(err => {
                    this.error = err;
                });
            });
        };

        this.recallCertification = function () {
            dialogService.confirm(['Återkalla begäran om attest']).then(() => {
                tromanServer.Payroll.recallCertification({
                    Id: paymentGroup.remuneration.Id,
                }).then(result => {
                    $uibModalInstance.close(new CertificationRecalledResult(result));
                }).catch(err => {
                    this.error = err;
                });
            });
        };
    }
]);
